module.exports = __webpack_public_path__ + "static/gestion-conocimiento-a5b1c0b5b652a7da4a23ab240b83f5c2.png";